function PageTitle({ title }) {
  return (
    <>
      <div className="text-white text-3xl font-poppins font-extrabold relative pb-2">
        {title}
      </div>
      <div className="absolute w-10 h-2 rounded-lg bg-purple-500"></div>
    </>
  );
}

export default PageTitle;
